import { useContext } from "react";
import { EmailContactModel } from "@attelas/shared";
import useSWR from "swr";
import { environment } from "../config/environment";
import { ToastContext } from "../context/ToastContext";
import { useSWRFetcher } from "./useSWRFetcher";

export const useContacts = (email: string | null) => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { data, isLoading, error } = useSWR<EmailContactModel[]>(
    email ? `${environment.apiUrl}/api/contacts/search?email=${encodeURIComponent(email)}` : null,
    (url: string) => fetcher(url),
    {
      onError: () => {
        showToast("The contact details failed to load, please try again later", "error");
      },
    }
  );

  return {
    contacts: data,
    isLoading,
    isError: !!error,
  };
};
